<template>
    <div class="property-search-map">
        <google-map-loader
                :cluster-config="clusterConfig"
                :favorite-option-enabled="favoriteOptionEnabled"
                :location="location"
                :map-config="mapConfigProcessed"
                :markers="markers"
                :property-details-route="propertyDetailsRoute"
                :content-height="contentHeight"
                @idle="handleIdleMapEvent"
        />
    </div>
</template>
<script>
    import './PropertySearchMap.scss';
    import GoogleMapLoader from "../../../GoogleMaps/components/GoogleMapLoader/GoogleMapLoader";
    import {LatLng} from "../../../GoogleMaps/classes/LatLng";
    import {PropertyMarker} from "../../../GoogleMaps/classes/PropertyMarker";
    import {MyPropertyMarker} from "../../../GoogleMaps/classes/MyPropertyMarker";
    import {PROPERTY_SEARCH_HEADER_PROPERTIES_UPDATED_MAP} from "../../../mixins/PropertySearchMixin";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";
    import debounce from "lodash/debounce";
    import get from "lodash/get";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import {mapGetters} from "vuex";
    import {ClusterRenderer} from '../../../GoogleMaps/classes/ClusterRenderer';

    export const GOOGLE_MAPS_MAP_MOVED = 'GoogleMaps:map-moved';
    export const SEARCH_MAP_CONFIG = {
        disableDefaultUI: true,
        fullscreenControl: false,
        styles: [
            {
                'featureType': 'poi',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
        ],
        zoom: 12,
        gestureHandling: 'cooperative',
    };

    export default {
        name: 'PropertySearchMap',

        mixins: [IsMobileMixin],

        components: {
            GoogleMapLoader,
        },

        props: {
            location: {
                type: Array,
                default: () => [],
            },
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            },
            mapConfig: {
                type: Object,
                default: () => {
                    return SEARCH_MAP_CONFIG;
                }
            },
            contentHeight: {
                type: Number,
                default: 0,
            }
        },

        data() {
            return {
                isLoading: true,
                markers: [],
            };
        },

        beforeMount() {
            this.$bus.$on(PROPERTY_SEARCH_HEADER_PROPERTIES_UPDATED_MAP, this.handlePropertiesUpdated);
        },

        computed: {
            ...mapGetters({
                coreProperty: 'getCoreProperty',
            }),
            mapConfigProcessed() {
                let mapCfg = SEARCH_MAP_CONFIG;
                for (let key in this.mapConfig) {
                    mapCfg[key] = this.mapConfig[key];
                }
                mapCfg.gestureHandling = this.isMobile || this.isTablet ? 'greedy' : 'cooperative';
                return mapCfg;
            },

            clusterConfig() {
                let isSold = this.markers.some((item) => {
                    return get(item, 'attributes.isSold', false);
                });
                return {
                    renderer: new ClusterRenderer({
                        isSold: isSold,
                    }),
                };
            },
        },

        methods: {
            handleIdleMapEvent(coordinates) {
                this.$bus.$emit(GOOGLE_MAPS_MAP_MOVED, coordinates);
            },

            /**
             * @param properties {Array.<PropertyAppResource>}
             */
            handlePropertiesUpdated({properties}) {
                this.isLoading = false;
                let tempMarkers = [];
                for (const property of properties) {
                    if (!property.details || !property.details.latitude || !property.details.longitude) {
                        continue;
                    }
                    if (this.coreProperty && property.uuid === this.coreProperty.uuid) {
                        property.isHOCoreProperty = true;
                        property.isFavorite = true;
                        tempMarkers.push(this.createMyPropertyMarker(property));
                        continue;
                    }
                    tempMarkers.push(this.createPropertyMarker(property));
                }
                this.markers = tempMarkers;

            },
            /**
             * @param propertyAppResource {PropertyAppResource}
             * @returns {PropertyMarker}
             */
            createPropertyMarker(propertyAppResource) {
                const latLng = new LatLng(propertyAppResource.details.latitude, propertyAppResource.details.longitude);
                return new PropertyMarker(latLng, propertyAppResource);
            },
            /**
             * @param propertyAppResource {PropertyAppResource}
             * @returns {MyPropertyMarker}
             */
            createMyPropertyMarker(propertyAppResource) {
                const latLng = new LatLng(propertyAppResource.details.latitude, propertyAppResource.details.longitude);
                return new MyPropertyMarker(latLng, propertyAppResource);
            },
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SEARCH_HEADER_PROPERTIES_UPDATED_MAP, this.handlePropertiesUpdated);
        }
    };
</script>

